export default "__VITE_ASSET__DSON4ON4__"